import { Button } from "../components/ui/button"
import { HelpCircle } from "lucide-react"


export function FloatingHelpButton({ onClick }) {
  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50">
      <Button
        onClick={onClick}
        className="rounded-full px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white shadow-lg transition-all duration-300 hover:scale-105"
        aria-label="Get Help"
      >
        <HelpCircle className="h-5 w-5 mr-2" />
        <span className="font-medium">Help</span>
      </Button>
    </div>
  )
}
